import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {HttpBackend, HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class RecoverPasswordService {
  private httpClient: HttpClient;

  constructor(httpBackend: HttpBackend) {
    this.httpClient = new HttpClient(httpBackend);
  }

  recoverPassword(username: string): Observable<any> {
    return this.httpClient.post(environment.apiUrl + '/passwordRecovery', {username});
  }

  newPassword(password1: string, password2: string, tokenString: string): Observable<any> {
    return this.httpClient.post(environment.apiUrl + '/newPassword', {password1, password2, tokenString})
  }

}
